module.exports = __webpack_public_path__ + "static/img/son2.31f928a7.png";